<template>
  <div class="zxbgbox">
    <div class="title">风控报告</div>
    <div class="presonInfo">(一)个人基本信息</div>
    <table class="bt20" border="1" width="94%" align="center" cellpadding="10" cellspacing="0">
      <tr align="center" height="30">
        <th style="background: rgb(221, 235, 247)" v-for="(item, index) in baseInfo" :key="index">
          {{ item.name }}
        </th>
      </tr>
      <tr align="center" height="30">
        <td v-for="(item, index) in baseInfo" :key="index">
          {{ funData(item.key, item.objs) }}
        </td>
      </tr>
    </table>
    <!-- <div class="title2">(一)信息概要</div> -->
    <!-- <div class="presonInfo">(一)个人信用报告“数字解读”</div>
      <table class="bt20" border="1" width="94%" align="center" cellpadding="10" cellspacing="0">
        <tr align="center" height="30" style="background: rgb(221, 235, 247);">
          <th v-for="(item, index) in numberInfo" :key="index">{{ item.name }}</th>
        </tr>
        <tr align="center" height="30">
          <td v-for="(item, index) in numberInfo" :key="index">{{ item.key }}</td>
        </tr>
      </table> -->
    <div class="presonInfo">(二)信贷交易信息提示</div>
    <table class="bt20" border="1" width="94%" align="center" cellpadding="10" cellspacing="0">
      <tr align="center" height="30" style="background: rgb(221, 235, 247)">
        <th :colspan="item.col" v-for="(item, index) in transactionInfo.titleList" :key="index">
          {{ item.name }}
        </th>
      </tr>
      <template v-for="(item, index) in transactionInfo.dataList">
        <tr align="center" height="30" v-for="(item2, index2) in item.children" :key="index2">
          <th :rowspan="item.children.length" v-if="index2 === 0">
            {{ item.name }}
          </th>
          <th>{{ item2.name }}</th>
          <td>{{ funData(item2.accountNumber) }}</td>
        </tr>
      </template>
    </table>
    <div class="presonInfo">(三)信贷交易违约信息概要</div>
    <table v-for="(item, index) in defaultInfo" :key="index" border="1"
      :class="{ bt20: index === defaultInfo.length - 1 }" width="94%" align="center" cellpadding="10" cellspacing="0">
      <tr align="center" height="30" style="background: rgb(221, 235, 247)">
        <th :colspan="item.col">{{ item.title }}</th>
      </tr>
      <tr align="center" v-if="item.titleList.length > 0" height="30">
        <th v-for="(item2, index2) in item.titleList" :key="index2">
          {{ item2 }}
        </th>
      </tr>
      <template v-for="(item3, index3) in item.dataList">
        <tr align="center" height="30" v-if="item.dataList.length > 0" :key="index3">
          <th v-if="item3.name">{{ item3.name }}</th>
          <td v-for="(item4, index4) in item3.dataKey" :key="index4">
            {{ funData(item4) }}
          </td>
        </tr>
      </template>
    </table>
    <div class="presonInfo">(四)信贷交易授信及负债信息概要(未结清/未销户)</div>
    <table v-for="(item, index) in creditInfo" :key="index" :class="{ bt20: index === creditInfo.length - 1 }"
      border="1" width="94%" align="center" cellpadding="10" cellspacing="0">
      <tr align="center" height="30" style="background: rgb(221, 235, 247)">
        <th :colspan="item.col">{{ item.title }}</th>
      </tr>
      <tr align="center" v-if="item.titleList.length > 0" height="30">
        <th v-for="(item2, index2) in item.titleList" :key="index2">
          {{ item2 }}
        </th>
      </tr>
      <template v-for="(item3, index3) in item.dataList">
        <tr align="center" height="30" v-if="item.dataList.length > 0" :key="index3">
          <th v-if="item3.name" :colspan="item3.col ? item3.col : 1">
            {{ item3.name }}
          </th>
          <td :colspan="item3.col ? item3.col : 1" v-for="(item4, index4) in item3.dataKey" :key="index4">
            {{ funData(item4) }}
          </td>
        </tr>
      </template>
    </table>
    <div class="presonInfo">(五)公共信息概要</div>
    <table v-for="(item, index) in publicInfo" :class="{ bt20: index === publicInfo.length - 1 }" :key="index"
      border="1" width="94%" align="center" cellpadding="10" cellspacing="0">
      <tr align="center" height="30" style="background: rgb(221, 235, 247)">
        <th :colspan="item.col">{{ item.title }}</th>
      </tr>
      <tr align="center" v-if="item.titleList.length > 0" height="30">
        <th v-for="(item2, index2) in item.titleList" :key="index2">
          {{ item2 }}
        </th>
      </tr>
      <template v-for="(item3, index3) in item.dataList">
        <tr align="center" height="30" :key="index3" v-if="item.dataList.length > 0">
          <th v-if="item3.name" :colspan="item3.col ? item3.col : 1">
            {{ item3.name }}
          </th>
          <td :colspan="item3.col ? item3.col : 1" v-for="(item4, index4) in item3.dataKey" :key="index4">
            {{ funData(item4) }}
          </td>
        </tr>
      </template>
    </table>
    <div class="presonInfo">(六)非循环贷未结清</div>
    <table v-for="(item, index) in nonCreditInfo2" :class="{ bt20: index === nonCreditInfo2.length - 1 }" :key="index"
      border="1" width="94%" align="center" cellpadding="10" cellspacing="0">
      <tr align="center" height="30" style="background: rgb(254, 241, 210)">
        <th :colspan="item.col">{{ item.title }}</th>
      </tr>
      <template v-for="(item3, index3) in item.dataList">
        <tr align="center" height="30" :key="index3" v-if="item.dataList.length > 0">
          <td :colspan="item4.col" v-for="(item4, index4) in item3.children" :key="index4">
            {{ item4.name ? item4.name : funData(item4.key) }}
          </td>
        </tr>
      </template>
    </table>
  </div>
</template>
<script>
import { zxViewReport } from "@/api/device";
import * as CryptoJS from "crypto-js";
export default {
  data() {
    return {
      orderNo: "",
      jsonData: {},
      name: "",
      idCard: "",
      objs: {
        10: "未婚",
        20: "已婚",
        30: "丧偶",
        40: "离婚",
        91: "单身",
        99: "未知",
      },
      baseInfo: [
        { name: "姓名", key: "name" },
        { name: "身份证号", key: "idCard" },
        {
          name: "学历", key: "A001-A001A-A2", objs: {
            10: '研究生',
            20: '本科',
            30: '大专',
            40: '中专，职高，技校',
            60: '高中',
            90: '其他',
            91: '初中及以下',
            99: '未知'
          }
        },
        { name: "婚姻状况", key: "A001-A001A-A1", objs: { 10: '未婚', 20: '已婚', 30: '丧偶', 40: '离婚', 91: '单身', 99: '未知' } },
        {
          name: "就业状况", key: "A001-A001A-A4", objs: {
            11: '国家公务员',
            13: '专业技术人员',
            17: '职员',
            21: '企业管理人员',
            24: '工人',
            27: '农民',
            31: '学生',
            37: '现役军人',
            51: '自由职业者',
            99: '其他'
          }
        },
        { name: "征信白户", key: "blankReport" },
        { name: "预测收入", key: "customRule-juRuiRule-A6" },
      ],
      transactionInfo: {
        titleList: [
          { name: "业务类型", col: 2 },
          { name: "账户数", col: 1 },
          // { name: '首笔业务发放月份', col: 1 },
        ],
        dataList: [
          {
            name: "贷款",
            col: 1,
            children: [
              {
                name: "个人住房贷款",
                accountNumber: "B001-B001A-A1",
                col: 1,
                month: "--",
              },
              {
                name: "个人商用房贷款(包括商住两用房)",
                accountNumber: "B001-B001A-A2",
                col: 1,
                month: "--",
              },
              {
                name: "其他类贷款",
                accountNumber: "B001-B001A-A3",
                col: 1,
                month: "---",
              },
            ],
          },
          {
            name: "信用卡",
            col: 1,
            children: [
              {
                name: "贷记卡",
                accountNumber: "B001-B001A-A4",
                col: 1,
                month: "---",
              },
              {
                name: "准贷记卡",
                accountNumber: "B001-B001A-A5",
                col: 1,
                month: "---",
              },
            ],
          },
          {
            name: "其他",
            col: 1,
            children: [
              {
                name: "",
                accountNumber: "B001-B001A-A3",
                col: 1,
                month: "---",
              },
            ],
          },
        ],
      },
      numberInfo: [
        { name: "信贷交易信息提示", key: "---" },
        { name: "交易信息提示", key: "---" },
      ],
      defaultInfo: [
        {
          title: "逾期(透支)信息汇总",
          titleList: [
            "账户类型",
            "账户数",
            "月份数",
            "单月最高逾期透支总额",
            "最长逾期/透支月数",
          ],
          dataList: [
            {
              name: "非循环贷账户",
              dataKey: [
                "B001-B001D-D1",
                "B001-B001D-D2",
                "B001-B001D-D3",
                "B001-B001D-D4",
              ],
            },
            {
              name: "循环额度下分账户",
              dataKey: [
                "B001-B001D-D5",
                "B001-B001D-D6",
                "B001-B001D-D7",
                "B001-B001D-D8",
              ],
            },
            {
              name: "循环贷账户",
              dataKey: [
                "B001-B001D-D9",
                "B001-B001D-D10",
                "B001-B001D-D11",
                "B001-B001D-D12",
              ],
            },
            {
              name: "贷记卡账户",
              dataKey: [
                "B001-B001D-D13",
                "B001-B001D-D14",
                "B001-B001D-D15",
                "B001-B001D-D16",
              ],
            },
            {
              name: "准贷记卡账户",
              dataKey: [
                "B001-B001D-D17",
                "B001-B001D-D18",
                "B001-B001D-D19",
                "B001-B001D-D20",
              ],
            },
          ],
          col: 5,
        },
        {
          title: "贷款或贷记卡信贷记录",
          titleList: [
            "近1年内逾期出现数字3及以上或者6次逾期",
            "近2年内逾期出现数字4及以上",
            "近3个月内逾期出现数字2及以上",
            "透支180天以上未付余额≥500元",
          ],
          dataList: [
            {
              name: "",
              dataKey: [
                "customRule-juRuiRule-A2",
                "customRule-juRuiRule-A3",
                "customRule-juRuiRule-A5",
                "customRule-juRuiRule-A4",
              ],
            },
          ],
          col: 4,
        },
        {
          title: "呆账状态",
          titleList: [],
          dataList: [{ name: "", dataKey: ["customRule-juRuiRule-A1"] }],
          col: 1,
        },
      ],
      creditInfo: [
        {
          title: "非循环贷账户信息汇总",
          titleList: [
            "管理机构数",
            "账户数",
            "授信总额",
            "余额",
            "最近6个月平均应还款",
          ],
          dataList: [
            {
              name: "",
              dataKey: [
                "B001-B001E-E15",
                "B001-B001E-E16",
                "B001-B001E-E17",
                "B001-B001E-E18",
                "B001-B001E-E19",
              ],
            },
          ],
          col: 5,
        },
        {
          title: "循环贷账户信息汇总",
          titleList: [
            "管理机构数",
            "账户数",
            "授信总额",
            "余额",
            "最近6个月平均应还款",
          ],
          dataList: [
            {
              name: "",
              dataKey: [
                "B001-B001E-E25",
                "B001-B001E-E26",
                "B001-B001E-E27",
                "B001-B001E-E28",
                "B001-B001E-E29",
              ],
            },
          ],
          col: 5,
        },
        {
          title: "贷记卡账户信息汇总",
          titleList: [
            "管理机构数",
            "账户数",
            "授信总额",
            "余额",
            "最近6个月平均应还款",
          ],
          dataList: [
            {
              name: "",
              dataKey: [
                "B001-B001E-E1",
                "B001-B001E-E2",
                "B001-B001E-E3",
                "B001-B001E-E4",
                "B001-B001E-E5",
              ],
            },
            { name: "最近6个月平均应使用额度", col: 6 },
            { name: "", col: 6, dataKey: ["B001-B001E-E7"] },
          ],
          col: 5,
        },
      ],
      publicInfo: [
        {
          title: "查询次数",
          titleList: [],
          dataList: [],
          col: 1,
        },
        {
          title: "查询次数-最近一个月内",
          titleList: ["机构查询", "本人查询"],
          dataList: [{ name: "", dataKey: ["F001-F001A-A5", "F001-F001A-A1"] }],
          col: 2,
        },
        {
          title: "查询原因",
          titleList: ["贷款审批", "信用卡审批", "消费金融", "小额贷款"],
          dataList: [
            {
              name: "",
              dataKey: [
                "customRule-juRuiRule-A7",
                "customRule-juRuiRule-A10",
                "customRule-juRuiRule-A13",
                "customRule-juRuiRule-A16",
              ],
            },
          ],
          col: 4,
        },
        {
          title: "最近3个月内",
          titleList: ["机构查询"],
          dataList: [{ name: "", dataKey: ["F001-F001A-A6"] }],
          col: 1,
        },
        {
          title: "查询原因",
          titleList: ["贷款审批", "信用卡审批", "消费金融", "小额贷款"],
          dataList: [
            {
              name: "",
              dataKey: [
                "customRule-juRuiRule-A8",
                "customRule-juRuiRule-A11",
                "customRule-juRuiRule-A14",
                "customRule-juRuiRule-A17",
              ],
            },
          ],
          col: 4,
        },
        {
          title: "最近6个月内",
          titleList: ["机构查询"],
          dataList: [{ name: "", dataKey: ["F001-F001A-A7"] }],
          col: 1,
        },
        {
          title: "查询原因",
          titleList: ["贷款审批", "信用卡审批", "消费金融", "小额贷款"],
          dataList: [
            {
              name: "",
              dataKey: [
                "customRule-juRuiRule-A9",
                "customRule-juRuiRule-A12",
                "customRule-juRuiRule-A15",
                "customRule-juRuiRule-A18",
              ],
            },
          ],
          col: 4,
        },
        {
          title: "最近2年内",
          titleList: ["贷后管理", "担保资格审查", "特约商户实名审查"],
          dataList: [
            {
              name: "",
              dataKey: ["B001-B001G-G6", "B001-B001G-G7", "B001-B001G-G8"],
            },
          ],
          col: 3,
        },
        {
          title: "查询机构数",
          titleList: [],
          dataList: [],
          col: 1,
        },
        {
          title: "查询原因",
          titleList: ["贷款审批", "信用卡审批"],
          dataList: [{ name: "", dataKey: ["B001-B001G-G1", "B001-B001G-G2"] }],
          col: 2,
        },
      ],
      nonCreditInfo2: [
        {
          title: "管理机构",
          dataList: [],
          col: 1,
        },
        {
          title: "汽车金融类",
          dataList: [
            {
              children: [
                { name: "借款总金额", col: 1, key: "" },
                { name: "借款总余额", col: 1, key: "" },
                { name: "最大剩余期数", col: 1, key: "" },
                { name: "月还款金额", col: 1, key: "" },
              ],
            },
            {
              children: [
                { name: "", col: 1, key: "customRule-juRuiRule-A19_1" },
                { name: "", col: 1, key: "customRule-juRuiRule-A19_2" },
                { name: "", col: 1, key: "customRule-juRuiRule-A19_3" },
                { name: "", col: 1, key: "customRule-juRuiRule-A19_4" },
              ],
            },
          ],
          col: 4,
        },
        {
          title: "消费金融类",
          dataList: [
            {
              children: [
                { name: "借款总金额", col: 1, key: "" },
                { name: "借款总余额", col: 1, key: "" },
                { name: "最大剩余期数", col: 1, key: "" },
                { name: "月还款金额", col: 1, key: "" },
              ],
            },
            {
              children: [
                { name: "", col: 1, key: "customRule-juRuiRule-A20_1" },
                { name: "", col: 1, key: "customRule-juRuiRule-A20_2" },
                { name: "", col: 1, key: "customRule-juRuiRule-A20_3" },
                { name: "", col: 1, key: "customRule-juRuiRule-A20_4" },
              ],
            },
          ],
          col: 4,
        },
        {
          title: "贷款类(含小额贷款公司)",
          dataList: [
            {
              children: [
                { name: "借款总金额", col: 1, key: "" },
                { name: "借款总余额", col: 1, key: "" },
                { name: "最大剩余期数", col: 1, key: "" },
                { name: "月还款金额", col: 1, key: "" },
              ],
            },
            {
              children: [
                { name: "", col: 1, key: "customRule-juRuiRule-A21_1" },
                { name: "", col: 1, key: "customRule-juRuiRule-A21_2" },
                { name: "", col: 1, key: "customRule-juRuiRule-A21_3" },
                { name: "", col: 1, key: "customRule-juRuiRule-A21_4" },
              ],
            },
          ],
          col: 4,
        },
      ],
      nonCreditInfo3: [
        {
          title: "逾期统计",
          dataList: [
            {
              children: [
                { name: "当前逾期总金额", col: 1, key: "" },
                { name: "当前最大逾期期数", col: 1, key: "" },
                { name: "当前单账户最大逾期总额", col: 1, key: "" },
                { name: "逾期31-60天未还本金总额", col: 1, key: "" },
                { name: "逾期61-90天未还本金总额", col: 1, key: "" },
                { name: "逾期91-180天未还本金总额", col: 1, key: "" },
              ],
            },
            {
              children: [
                { name: "当前逾期总金额", col: 1, key: "---" },
                { name: "当前最大逾期期数", col: 1, key: "---" },
                { name: "当前单账户最大逾期总额", col: 1, key: "---" },
                { name: "逾期31-60天未还本金总额", col: 1, key: "---" },
                { name: "逾期61-90天未还本金总额", col: 1, key: "---" },
                { name: "逾期91-180天未还本金总额", col: 1, key: "---" },
              ],
            },
            {
              children: [
                { name: "逾期180天以上未还本金总额", col: 1, key: "" },
                { name: "最近3个月累计逾期次数", col: 1, key: "" },
                { name: "最近6个月累计逾期次数", col: 1, key: "" },
                { name: "最近12个月累计逾期次数", col: 1, key: "" },
                { name: "最近3个月连续逾期次数", col: 1, key: "" },
                { name: "最近6个月连续逾期次数", col: 1, key: "" },
              ],
            },
            {
              children: [
                { name: "逾期180天以上未还本金总额", col: 1, key: "---" },
                { name: "最近3个月累计逾期次数", col: 1, key: "---" },
                { name: "最近6个月累计逾期次数", col: 1, key: "---" },
                { name: "最近12个月累计逾期次数", col: 1, key: "---" },
                { name: "最近3个月连续逾期次数", col: 1, key: "---" },
                { name: "最近6个月连续逾期次数", col: 1, key: "---" },
              ],
            },
            {
              children: [{ name: "最近12个月连续逾期次数", col: 6, key: "" }],
            },
            {
              children: [
                { name: "最近12个月连续逾期次数", col: 6, key: "---" },
              ],
            },
          ],
          col: 6,
        },
        {
          title: "业务种类",
          dataList: [],
          col: 6,
        },
        {
          title: "住房贷款",
          dataList: [
            {
              children: [
                { name: "当前逾期账户数", col: 1, key: "" },
                { name: "当前逾期总金额", col: 1, key: "" },
                { name: "当期逾期最大期数", col: 1, key: "" },
                { name: "当期逾期单笔最大金额", col: 1, key: "" },
                { name: "逾期31-60天未还本金总额", col: 1, key: "" },
                { name: "逾期61-90天未还本金总额", col: 1, key: "" },
              ],
            },
            {
              children: [
                { name: "当前逾期账户数", col: 1, key: "---" },
                { name: "当前逾期总金额", col: 1, key: "---" },
                { name: "当期逾期最大期数", col: 1, key: "---" },
                { name: "当期逾期单笔最大金额", col: 1, key: "---" },
                { name: "逾期31-60天未还本金总额", col: 1, key: "---" },
                { name: "逾期61-90天未还本金总额", col: 1, key: "---" },
              ],
            },
            {
              children: [
                { name: "逾期91-180天未还本金总额", col: 1, key: "" },
                { name: "逾期180天以上未还本金总额", col: 5, key: "" },
              ],
            },
            {
              children: [
                { name: "逾期91-180天未还本金总额", col: 1, key: "---" },
                { name: "逾期180天以上未还本金总额", col: 5, key: "---" },
              ],
            },
          ],
          col: 6,
        },
        {
          title: "个人汽车消费",
          dataList: [
            {
              children: [
                { name: "当前逾期账户数", col: 1, key: "" },
                { name: "当前逾期总金额", col: 1, key: "" },
                { name: "当期逾期最大期数", col: 1, key: "" },
                { name: "当期逾期单笔最大金额", col: 1, key: "" },
                { name: "逾期31-60天未还本金总额", col: 1, key: "" },
                { name: "逾期61-90天未还本金总额", col: 1, key: "" },
              ],
            },
            {
              children: [
                { name: "当前逾期账户数", col: 1, key: "---" },
                { name: "当前逾期总金额", col: 1, key: "---" },
                { name: "当期逾期最大期数", col: 1, key: "---" },
                { name: "当期逾期单笔最大金额", col: 1, key: "---" },
                { name: "逾期31-60天未还本金总额", col: 1, key: "---" },
                { name: "逾期61-90天未还本金总额", col: 1, key: "---" },
              ],
            },
            {
              children: [
                { name: "逾期91-180天未还本金总额", col: 1, key: "" },
                { name: "逾期180天以上未还本金总额", col: 5, key: "" },
              ],
            },
            {
              children: [
                { name: "逾期91-180天未还本金总额", col: 1, key: "---" },
                { name: "逾期180天以上未还本金总额", col: 5, key: "---" },
              ],
            },
          ],
          col: 6,
        },
      ],
      relatedRepayment: [
        {
          title: "统计",
          dataList: [
            {
              children: [
                { name: "主借款账户还款状态不正常的账户数", col: 1, key: "" },
                {
                  name: "主借款账户还款状态不正常的账户总余额",
                  col: 1,
                  key: "",
                },
              ],
            },
            {
              children: [
                {
                  name: "主借款账户还款状态不正常的账户数",
                  col: 1,
                  key: "---",
                },
                {
                  name: "主借款账户还款状态不正常的账户总余额",
                  col: 1,
                  key: "---",
                },
              ],
            },
          ],
          col: 2,
        },
      ],
      latestFund: [
        {
          title: "",
          dataList: [
            {
              children: [
                { name: "缴费状态", col: 1, key: "" },
                { name: "参缴日期", col: 1, key: "" },
                { name: "缴至月份", col: 1, key: "" },
                { name: "月缴存额", col: 1, key: "" },
                { name: "个人缴存比例", col: 1, key: "" },
              ],
            },
            {
              children: [
                { name: "缴费状态", col: 1, key: "---" },
                { name: "参缴日期", col: 1, key: "---" },
                { name: "缴至月份", col: 1, key: "---" },
                { name: "月缴存额", col: 1, key: "---" },
                { name: "个人缴存比例", col: 1, key: "---" },
              ],
            },
          ],
          col: 5,
        },
      ],
      queryRecord: [
        {
          title: "",
          dataList: [
            {
              children: [
                { name: "查询日期", col: 1, key: "" },
                { name: "查询机构类型", col: 1, key: "" },
                { name: "查询原因", col: 1, key: "" },
              ],
            },
            {
              children: [
                { name: "查询日期", col: 1, key: "---" },
                { name: "查询机构类型", col: 1, key: "---" },
                { name: "查询原因", col: 1, key: "---" },
              ],
            },
            {
              children: [
                { name: "查询日期", col: 1, key: "---" },
                { name: "查询机构类型", col: 1, key: "---" },
                { name: "查询原因", col: 1, key: "---" },
              ],
            },
            {
              children: [
                { name: "查询日期", col: 1, key: "---" },
                { name: "查询机构类型", col: 1, key: "---" },
                { name: "查询原因", col: 1, key: "---" },
              ],
            },
          ],
          col: 3,
        },
      ],
    };
  },
  // 监听url上的参数
  watch: {
    "$route.query": {
      handler(newVal) {
        if (newVal) {
          const code = this.$route.params.code
          this.orderNo = this.decryption(decodeURIComponent(code), "7acf0ceadc391516");
          //   this.idCard = newVal.idCard;
          //   this.name = newVal.name;
          this.getZxRecord();
        }
        // 处理路由变化逻辑
      },
      immediate: true, // 立即执行
      deep: true, // 深度监听，监听对象属性的变化
    },
  },
  methods: {
    decryption(src, keyWord) {
      const key = CryptoJS.enc.Utf8.parse(keyWord);
      // 解密逻辑
      const decryptd = CryptoJS.AES.decrypt(src, key, {
        iv: key,
        mode: CryptoJS.mode.CFB,
        padding: CryptoJS.pad.NoPadding,
      });

      return decryptd.toString(CryptoJS.enc.Utf8);
      // return decryptd.toString();
    },
    async getZxRecord() {
      console.log("查询征信");
      const res = await zxViewReport({ orderNo: this.orderNo });
      this.jsonData = res.data.rules;
      this.name = res.data.name;
      this.idCard = res.data.idCard;
      console.log(res, "res");
    },
    funData(fkey, obj) {
      if (fkey === "name") return this.name;
      if (fkey === "idCard") return this.idCard;
      if (fkey === "blankReport")
        return this.jsonData[fkey] == "1" ? "是" : "否";
      const keyarry = fkey.split("-");
      const key1 = keyarry[0];
      const key2 = keyarry[1];
      const key3 = keyarry[2];
      console.log(key1, key2);
      if (obj) {
        return obj[this.jsonData?.[key1]?.[key2]?.[key3]];
      }
      return this.jsonData?.[key1]?.[key2]?.[key3];
    },
  },
};

// 2.信贷交易信息提示
</script>
<style lang="less" scoped>
.zxtips {
  line-height: 40px;
}

.pd20 {
  padding: 10px;
}

.zxbgbox {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px;

  .zxtitle {
    padding: 20px 0;
    font-weight: 700;
  }

  .zxrow {
    padding: 0 0 10px 0;
    font-weight: 700;
  }

  .title {
    padding: 30px 0;
    font-weight: 700;
  }

  .title2 {
    padding: 5px 0;
    font-weight: 700;
  }

  .presonInfo {
    font-weight: 700;
  }
}

table {
  border-collapse: collapse;
  border: 1px solid black;
}

td,
th {
  border: 1px solid black;
}

.bt20 {
  margin-bottom: 20px;
}
</style>
